export const Events = {
  ADD_ITEM: 'px.headerCart.add',
  REMOVE_ITEM: 'px.headerCart.remove',
  ENABLE: 'px.headerCart.enable',
  PROPS: 'px.headerCart.props'
};

export const PeriodUnits = {
  MONTH: 'MONTH',
  ONE_TIME: 'ONE_TIME',
  QUARTER: 'QUARTER',
  SEMI_ANNUAL: 'SEMI_ANNUAL',
  YEAR: 'YEAR'
};

export const MarketConstants = {
  COOKIE_KEY: 'market',
  DEFAULT_MARKET_KEY: 'en'
};

export const CurrencyConstants = {
  COOKIE_KEY: 'currency',
  DEFAULT_CURRENCY_KEY: 'USD'
};

export const StringConstants = {
  BUNDLE_OFFER: 'BUNDLE OFFER',
  WITH_DOMAIN_PRIVACY: 'Private',
  NO_DOMAIN_PRIVACY: 'Public'
};

export const DisplayTaxesAndFees = {
  NONE: 0,
  ALL: 1,
  ICANN: 2,
  TAXES: 3
};

export const DomainProductTypes = [2, 3, 4, 5, 19, 20, 38, 93, 378];
